import { featureToggles } from '@otto-ec/eprivacy-shared'

export const IS_ONETRUST_INTERNAL_HOSTING_ENABLED_TOGGLE_KEY =
  'cb_onetrust_internal_hosting'

export function isOneTrustInternalHostingEnabled(): boolean {
  return featureToggles(IS_ONETRUST_INTERNAL_HOSTING_ENABLED_TOGGLE_KEY, false)
}
